
import Vue from "vue";
import Component from "vue-class-component";

import IconButton from "@/components/basic/IconButton.vue";
import RequestButton from "@/components/basic/RequestButton.vue";
import ErrorMessage from "@/components/basic/ErrorMessage.vue";

import Checkbox from "@/components/form/Checkbox.vue";

import PaginatedDataTable from "@/components/collection/new/PaginatedDataTable.vue";

import {
  PropertyListModel,
  tableHeaders
} from "../../models/PropertyListModel";
import { Authorizator } from "@/common/interactors/Authorizator";
import { PropertyModel } from "../../models/PropertyModel";
import { PropertyPlanSelectionReloader } from "@/property/shared/interactors/PropertyPlanSelectionReloader";

@Component<PropertyList>({
  components: {
    IconButton,
    RequestButton,
    ErrorMessage,
    Checkbox,
    PaginatedDataTable
  },
  props: {
    search: {
      type: String,
      default: ""
    },
    cadastralCommunity: {
      type: String,
      default: undefined
    },
    assetNumber: {
      type: String,
      default: undefined
    },
    redirectOnSingleMatch: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    search(search: string) {
      this.load(1);
    },
    cadastralCommunity() {
      this.load(1);
    },
    assetNumber() {
      this.load(1);
    },
    selectedProperties() {
      this.init();
    }
  }
})
export default class PropertyList extends Vue {
  protected model = new PropertyListModel();
  protected search!: string;
  protected cadastralCommunity?: string;
  protected assetNumber?: string;
  protected redirectOnSingleMatch!: boolean;

  private hasRedirected = false;

  protected get headers() {
    return tableHeaders;
  }

  protected get selectedProperties() {
    return this.$store.state.property.selectedProperties;
  }

  protected get editPropertyButtonVisible() {
    return Authorizator.canEditProperties();
  }

  protected getSelectedPropertyButtonState(property: PropertyModel) {
    const onePropertySelected = this.$store.getters.hasOnePropertySelected;

    return {
      visible: Authorizator.canSelectProperties(),
      color: property.selected ? "accent" : "primary",
      confirm: !property.selected && !onePropertySelected,
      tooltipText: property.selected
        ? "Gebäude entwählen"
        : onePropertySelected
        ? "Zur Auswahl hinzufügen"
        : "Gebäude auswählen"
    };
  }

  protected mounted() {
    this.load();
  }

  protected async load(page = 1) {
    await this.model.load(
      page,
      this.search,
      this.cadastralCommunity,
      this.assetNumber
    );

    if (
      this.redirectOnSingleMatch &&
      !this.hasRedirected &&
      page === 1 &&
      this.model.properties.length === 1
    ) {
      this.hasRedirected = true;
      this.goToProperty(this.model.properties[0].id.toString());
      return;
    }

    this.init();
  }

  protected init() {
    this.model.selectProperties(this.selectedProperties);
  }

  protected goToProperty(id: string) {
    this.$router.push({ name: "property", params: { propertyId: id } });
  }

  protected async selectProperty(property: PropertyModel) {
    this.$store.dispatch("selectProperty", property);

    if (await this.model.selectProperty(property)) {
      await PropertyPlanSelectionReloader.reloadForPropertyIds(
        this.model.selectedProperties.map(p => p.id)
      );
    }
  }
}
